var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tb-list" },
    [
      _c(
        "wallet-table",
        {
          staticClass: "wallet-sbp-table",
          attrs: {
            headList: [
              {
                class: "name __ellipsis",
                text: _vm.$t("walletSBP.section1.nodeName"),
                cell: "name",
                slot: true
              },
              {
                class: "block-addr",
                text: _vm.$t("walletSBP.section1.producerAddr"),
                cell: "blockProducingAddress",
                slot: true
              },
              {
                class: "reward-addr",
                text: _vm.$t("walletSBP.section1.rewardWithdrawAddress"),
                cell: "rewardWithdrawAddress",
                slot: true
              },
              {
                class: "amount",
                text: _vm.$t("stakingAmount"),
                cell: "amount"
              },
              {
                class: "height",
                text: _vm.$t("withdrawHeight"),
                cell: "height"
              },
              {
                class: "operate",
                text: _vm.$t("action"),
                cell: "operate"
              }
            ],
            contentList: _vm.list
          },
          scopedSlots: _vm._u([
            {
              key: "name",
              fn: function(ref) {
                var data = ref.data
                return [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://vitescan.io/address/" + data.stakeAddress,
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(data.name))]
                  )
                ]
              }
            },
            {
              key: "blockProducingAddress",
              fn: function(ref) {
                var data = ref.data
                return [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://vitescan.io/address/" +
                          data.blockProducingAddress,
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("shortAddr")(data.blockProducingAddress)
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  data.blockProducingAddress === _vm.address
                    ? _c("span", { staticClass: "beneficial-img" })
                    : _vm._e()
                ]
              }
            },
            {
              key: "rewardWithdrawAddress",
              fn: function(ref) {
                var data = ref.data
                return [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://vitescan.io/address/" +
                          data.rewardWithdrawAddress,
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("shortAddr")(data.rewardWithdrawAddress)
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  data.rewardWithdrawAddress === _vm.address
                    ? _c("span", { staticClass: "beneficial-img" })
                    : _vm._e()
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _vm._l(_vm.list, function(item, i) {
            return _c(
              "span",
              {
                key: i,
                attrs: { slot: i + "heightBefore" },
                slot: i + "heightBefore"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(item.isCancel ? "--" : item.withdrawHeight) +
                    "\n            "
                ),
                !item.isCancel
                  ? _c(
                      "i",
                      {
                        staticClass: "tipsicon __pointer",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.showTime(i)
                          }
                        }
                      },
                      [
                        _c("tooltips", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTimeTips === i,
                              expression: "showTimeTips === i"
                            },
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: _vm.hideTime,
                              expression: "hideTime"
                            }
                          ],
                          staticClass: "sbp-tooltips",
                          attrs: {
                            content: _vm.$t("walletSBP.section2.expireDate", {
                              time: item.time
                            })
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.list, function(item, i) {
            return _c(
              "span",
              {
                key: i,
                attrs: { slot: i + "operateBefore" },
                slot: i + "operateBefore"
              },
              [
                item.isStakingAddr
                  ? [
                      !item.isCancel
                        ? _c(
                            "span",
                            {
                              staticClass: "btn __pointer",
                              on: {
                                click: function($event) {
                                  return _vm.edit(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("btn.edit")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.isCancel
                        ? _c(
                            "span",
                            {
                              staticClass: "btn",
                              class: {
                                __pointer: item.isReReg,
                                unuse: !item.isReReg
                              },
                              on: {
                                click: function($event) {
                                  return _vm.reg(item, true)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("btn.reReg")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !item.isCancel
                        ? _c(
                            "span",
                            {
                              staticClass: "btn",
                              class: {
                                __pointer: item.isMaturity,
                                unuse: !item.isMaturity
                              },
                              on: {
                                click: function($event) {
                                  return _vm.cancel(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("walletSBP.cancelBtn")))]
                          )
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "btn __pointer",
                    on: {
                      click: function($event) {
                        return _vm.reward(item)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("walletSBP.rewardBtn")))]
                )
              ],
              2
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "password",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowReward,
              expression: "isShowReward"
            }
          ],
          attrs: {
            title: _vm.$t("walletSBP.rewardConfirm.title"),
            submitTxt: _vm.$t("walletSBP.rewardConfirm.rightBtn"),
            cancelTxt: _vm.$t("walletSBP.rewardConfirm.leftBtn"),
            isShowPWD: _vm.isShowPWD,
            cancel: _vm.hideReward,
            submit: _vm.sendReward
          }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("walletSBP.rewardConfirm.describe1", {
                  time: this.getTime(new Date().getTime())
                })
              ) +
              "\n        "
          ),
          _c("div", { staticClass: "__unuse_input __input_row __bold" }, [
            _vm._v("dSLS\n            "),
            _c("span", { staticClass: "__right" }, [
              _vm._v(_vm._s(_vm.totalReward || "--"))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "__hint" }, [
            _c("span", [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("walletSBP.rewardConfirm.describe2")) +
                  "\n                "
              ),
              _c(
                "a",
                {
                  staticClass: "link",
                  attrs: {
                    target: "_blank",
                    href: _vm.getUrl(
                      _vm.rewardItem && _vm.rewardItem.rawData.name
                    )
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("walletSBP.rewardConfirm.describe3")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("walletSBP.rewardConfirm.describe4")) +
                  "\n            "
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }